<h3
  [id]="headingId"
  class="border-mib-hairline border-b pb-2 text-xs font-medium tracking-wider text-gray-500 uppercase">
  {{ legend() }}
</h3>

<!-- No rule between two rows: a line says a section starts, and these are one section. -->
<div role="group" [attr.aria-labelledby]="headingId">
  @for (row of rows; track row.type) {
    <mai-toggle-row
      [label]="row.label"
      [description]="row.description"
      [checked]="isDisplayed(row.type)"
      [pending]="pending()"
      (checkedChange)="toggle(row.type, $event)"></mai-toggle-row>
  }
</div>
